import { t_JoystickDataset } from '../movements/joystick-movements/joystick-movements.component';
import { t_dataName } from '../../../../services/apiHandler/basicMachineFunctions/basic-machine-functions.service';

export const visualizationJoystickConfig = {
    dataNames: [
        {
            dataName: 'JoystickLeftForwardBackward',
            generalName: 'Joystick Left / Forward Backward',
        },
        {
            dataName: 'JoystickLeftLeftRight',
            generalName: 'Joystick Left / Left Right',
        },
        {
            dataName: 'JoystickLeftPalmGripLeftForwardBackward',
            generalName: 'Joystick Left Palm Grip / Forward Backward',
        },
        {
            dataName: 'JoystickLeftPalmGripLeftLeftRight',
            generalName: 'Joystick Left Palm Grip / Left Right',
        },
        {
            dataName: 'JoystickRightForwardBackward',
            generalName: 'Joystick Right / Forward Backward',
        },
        {
            dataName: 'JoystickRightLeftRight',
            generalName: 'Joystick Right / Left Right',
        },
        {
            dataName: 'JoystickRightPalmGripLeftForwardBackward',
            generalName: 'Joystick Right Palm Grip / Forward Backward',
        },
        {
            dataName: 'JoystickRightPalmGripLeftLeftRight',
            generalName: 'Joystick Right Palm Grip / Left Right',
        },
    ],
};

export const joystickDataConfig: t_JoystickDataset[] = [
    {
        joystickName: 'Joystick Left',
        forwardBackward: { dataname: { name: 'JoystickLeftForwardBackward' }, value: 0 },
        leftRight: { dataname: { name: 'JoystickLeftLeftRight' }, value: 0 },
    },
    {
        joystickName: 'Joystick Right',
        forwardBackward: { dataname: { name: 'JoystickRightForwardBackward' }, value: 0 },
        leftRight: { dataname: { name: 'JoystickRightLeftRight' }, value: 0 },
    },
    {
        joystickName: 'Joystick Left Palm Grip',
        forwardBackward: {
            dataname: { name: 'JoystickLeftPalmGripLeftForwardBackward' },
            value: 0,
        },
        leftRight: { dataname: { name: 'JoystickLeftPalmGripLeftLeftRight' }, value: 0 },
    },
    {
        joystickName: 'Joystick Right Palm Grip',
        forwardBackward: {
            dataname: { name: 'JoystickRightPalmGripLeftForwardBackward' },
            value: 0,
        },
        leftRight: { dataname: { name: 'JoystickRightPalmGripLeftLeftRight' }, value: 0 },
    },
];
